exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navigation__externalLink__3B4mB .navigation__externalIcon__3QWSf {\n  width: 0;\n  height: 18px;\n  opacity: 0;\n  transition-duration: .15s;\n  transition-property: opacity, width, margin;\n}\n.navigation__externalLink__3B4mB:hover .navigation__externalIcon__3QWSf {\n  opacity: .75;\n  width: 18px;\n  margin-right: 6px;\n}\n", ""]);

// exports
exports.locals = {
	"externalLink": "navigation__externalLink__3B4mB",
	"externalIcon": "navigation__externalIcon__3QWSf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"importLoaders":2,"localIdentName":"[name]__[local]__[hash:base64:5]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2122/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/navigation.less
// module id = UTYm
// module chunks = 1